import { render, staticRenderFns } from "./com_wechat_uploadimg.vue?vue&type=template&id=513aa027"
import script from "./com_wechat_uploadimg.vue?vue&type=script&lang=js"
export * from "./com_wechat_uploadimg.vue?vue&type=script&lang=js"
import style0 from "./com_wechat_uploadimg.vue?vue&type=style&index=0&id=513aa027&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports